import { createInstance } from '@/helpers/api/base'
import { useAuthStore } from '@/store/auth-store'
import { Log } from '@/types/logs'
import { useAppQuery } from '@/helpers/api/query'

interface IUnfinishedLogsResponse {
    id: string
    createdAt: string
    dutyFrom: string
    dutyTo: string
    dutyCode: string
    unfinishedLogs: Log[]
}

export const useGetUnfinishedLogs = () => {
    const { xUserShiftId } = useAuthStore()

    return useAppQuery<IUnfinishedLogsResponse>({
        queryKey: ['unfinishedLogs', xUserShiftId],
        queryFn: ({ queryKey }) =>
            createInstance({
                url: `/user-shifts/${queryKey[1]}/summary`,
                method: 'GET',
            }),
        enabled: !!xUserShiftId,
    })
}
